<header
  class="account__setup--header relative"
  style="align-items: center"
  [ngClass]="{
    '': switchFromUser,
    'mt-0': !switchFromUser
  }"
>
  <p class="font-open-sans text-base font-semibold leading-6 mb-0 text-[#000000de]">{{ menus[0]?.data_type }}</p>
  <div class="flex items-center gap-4">
    <button matTooltipPosition="above" data-dismiss="modal" class="bg-white" (click)="closeSideNav()">
      <span class="material-icons relative bg-white text-[#898F9E] text-2xl">clear</span>
    </button>
  </div>
</header>

<section
  [ngClass]="{
    'app__discovery_section--content-update mt-[4px]': switchFromUser,
    'app__discovery_section--content mt-[4px]': !switchFromUser
  }"
>
  <!-- side-nav section -->
  <ng-container>
    @if (isLoading) {
    <div class="nav w-[253px]">
      <nav class="w-full h-full">
        <ul class="w-full h-full mt-[20px] overflow-y-auto scroll-container pb-[90px]">
          @for (item of ['', '', '', '']; track item) {
          <li class="app__stepper__config-stepitem p-0">
            <div class="app__itemCard-radioButton-placeholder flex justify-between">
              <p class="app__checklistCarditem-label"></p>
              <p class="app__checklistCarditem-pil'"></p>
            </div>
          </li>
          }
        </ul>
      </nav>
    </div>
    }@else {
    <div
      class="nav w-[253px] min-w-[253px] inline-block pt-[20px] mr-[1px] overflow-y-auto"
      [style.max-height]="switchFromUser ? 'calc(100vh - 121px)' : 'calc(100vh - 70px)'"
      style="box-shadow: 0px 1px 1px 0px #00000024"
    >
      @for (item of menus; track $index) {
      <span
        class="flex justify-between w-full pl-[48px] py-5 pr-[47px] h-[60px]"
        [ngClass]="{ 'bg-[#F8F9FD]': item.configuration_group === this.menus[this.selectedStepIndex]?.configuration_group }"
        (click)="selectMenu(item, $index)"
      >
        <span class="cursor-pointer">
          <div class="flex gap-2 items-center">
            <!-- @if(discoveryCategoryConfigType?.name === "Financial Accounts" && $index !== 0) {
            <img class="h-4" src="{{ this.financialSteps[0]?.image }}" alt="green-check" />
            } -->
            @if(discoveryCategoryConfigType?.name === "Financial Accounts" && $index !== 0) {
            <div
              class="text-sm sidenav-text-tooltip"
              appTooltip
              [toolTipText]="item.configuration_group"
              [ngClass]="[
                item.configuration_group === this.menus[this.selectedStepIndex]?.configuration_group
                  ? ' text-[#18191C] font-semibold'
                  : 'text-[#898F9E] font-normal'
              ]"
            >
              {{ item.configuration_group }}
            </div>
            }@else{
            <div
              class="text-sm sidenav-text-tooltip"
              appTooltip
              [toolTipText]="item.configuration_group"
              [ngClass]="[
                item.configuration_group === this.menus[this.selectedStepIndex]?.configuration_group
                  ? ' text-[#18191C] font-semibold'
                  : 'text-[#898F9E] font-normal'
              ]"
            >
              {{ item.configuration_group === 'Financial Accounts' ? 'Financial Integrations' : item.configuration_group }}
            </div>
            }
          </div>
        </span>
      </span>
      }
      <span
        class="flex justify-between w-full pl-[48px] py-5 pr-[50px] h-[60px]"
        [ngClass]="{ 'bg-[#F8F9FD]': !this.menus[this.selectedStepIndex] }"
        (click)="selectMenu()"
      >
        <span class="cursor-pointer">
          <div
            class="text-sm sidenav-text-tooltip"
            appTooltip
            [ngClass]="!this.menus[this.selectedStepIndex] ? ' text-[#18191C] font-semibold' : 'text-[#898F9E] font-normal'"
          >
            Status
          </div>
        </span>
      </span>
    </div>
    }
  </ng-container>

  <div
    class="w-full h-full pl-[42px] pt-[47px] relative mx-auto bg-[#FAFAFA] overflow-y-auto"
    [ngClass]="{
      'mt-[2px]': switchFromUser,
      'pr-[18px]': discoveryCategoryConfigType?.name == 'Financial Accounts' && selectedStepIndex === 0,
      'pr-[38px]': discoveryCategoryConfigType?.name == 'Financial Accounts' && selectedStepIndex !== 0,
      'pr-[42px]': discoveryCategoryConfigType?.name != 'Financial Accounts'
    }"
    style="box-shadow: 0px 1px 1px 0px #00000024"
  >
    <section class="mx-auto relative" [ngStyle]="{ height: switchFromUser ? 'calc(100% - 72px)' : 'calc(100% - 21px)' }">
      @if(isLoading){
      <div class="pt-[42px]">
        <div class="rounded-xl h-60 w-full border bg-white flex items-center justify-center flex-col p-5 px-10">
          <div class="grid place-content-center place-items-center">
            <div class="payment-success-animation flex items-center">
              <ng-lottie width="142px" height="142px" [options]="questionContentAnimationOptions"></ng-lottie>
            </div>
            <p class="text-base font-semibold m-0 text-[#18191C]">One moment while we search for existing Items</p>
          </div>
        </div>
      </div>
      }@else{ @if(!menus[selectedStepIndex]){
      <discovery-configuration-status
        [menus]="menus"
        [isOwnerRegisterDataType]="isOwnerRegisterDataType"
        [discoveryCategoryConfigType]="discoveryCategoryConfigType"
        (setFinalStepValue)="completeDiscoveryType()"
      ></discovery-configuration-status>
      }@else if(discoveryCategoryConfigType?.name == "Financial Accounts" && selectedStepIndex === 0){
      <div>
        @if(selectedStepIndex === 0){
        <div class="font-open-sans text-xl text-[#53565B] font-semibold w-[687px]">
          Get live data for your <span class="font-bold text-[#25508E]">Financial Accounts</span>
        </div>
        <div class="font-open-sans mt-2 text-sm text-[#18191C] font-normal w-[687px]">
          Utilize our financial integrations to import financial accounts. This will allow you to view current balances & historical transactions all
          in one place.
        </div>
        <add-institution [switchFromUser]="switchFromUser" (closeSideDrawerEmitter)="closeSideNav()" [isFromDiscovery]="true"></add-institution>
        }
      </div>
      }@else{
      <div>
        @if(discoveryCategoryConfigType?.name == "Financial Accounts" && selectedStepIndex === 1){
        <div class="font-open-sans text-xl text-[#53565B] font-semibold w-[687px]">
          Add your <span class="font-bold text-[#25508E]">Other Financial Accounts</span>
        </div>
        <div class="font-open-sans mt-2 text-sm text-[#18191C] font-normal w-[687px]">
          For any institutions which were not able to connect via our integrations, you can add them manually here.
        </div>
        }@else{ @if(this.menus[this.selectedStepIndex]?.paths?.length && this.menus[this.selectedStepIndex]?.paths[0]?.list_sub_text){

        <div
          class="font-open-sans text-xl font-semibold text-[#53565B] mb-[18px]"
          [innerHTML]="this.menus[this.selectedStepIndex]?.configuration_group_question"
        ></div>
        <div
          class="font-open-sans text-sm font-normal text-[#18191C] mb-[18px]"
          [innerHTML]="this.menus[this.selectedStepIndex]?.paths[0]?.list_sub_text"
        ></div>

        }@else{
        <div
          class="font-open-sans text-xl font-semibold text-[#53565B] mb-[18px]"
          [innerHTML]="this.menus[this.selectedStepIndex]?.configuration_group_question"
        ></div>
        }
        <div>
          <mat-form-field id="access-manager-matAutoComplete" matTooltipClass="add-member-tooltip" class="discovery-config-search-alignment">
            <div matPrefix class="mr-1 matPrefix-search-icon"><img src="assets/images/search-blue.svg" width="18px" height="18px" /></div>
            <input
              type="text"
              matInput
              aria-label="Number"
              [(ngModel)]="searchQuery"
              placeholder="Search"
              class="text-sm font-normal text-[#707070]"
              #inputField
              (ngModelChange)="processFilteredPaths()"
            />
            @if (searchQuery?.length > 0) {
            <div matSuffix (click)="onClearInput()">
              <mat-icon class="close-input-icon mr-4 cursor-pointer">close</mat-icon>
            </div>
            }
          </mat-form-field>
        </div>
        } @if(this.menus[this.selectedStepIndex]?.paths && filteredPaths?.length === 0) {
        <div class="template-group-list" [ngClass]="{ 'pt-[112px]': switchFromUser, 'pt-[124px]': !switchFromUser }">
          <div class="flex-center fl-col gap-5 fl-al-center mt-6">
            <div><img height="200" width="200" class="h-[200px] w-[200px]" src="assets/images/no-matchin-result.svg" /></div>
            <div class="flex fl-col fl-al-center">
              <div class="text-2xl font-sans font-semibold text-[#18191C]">No matching results to show</div>
              <div class="font-normal text-base text-[#18191C] mt-[12px]">Try different search terms</div>
            </div>
          </div>
        </div>
        }@else { @if(discoveryCategoryConfigType?.name !== "Financial Accounts"){
        <div class="text-[#18191C] text-sm font-semibold mt-[42px] font-open-sans">
          Template Types <span class="font-bold text-[#000000]">({{ filteredPaths?.length }})</span>
        </div>
        }
        <div class="discovery-template-type-list">
          <div
            class="mt-[24px] flex flex-col gap-[16px] discovery-accordion-container"
            [style.max-height]="
              switchFromUser
                ? discoveryCategoryConfigType?.name == 'Financial Accounts'
                  ? 'calc(100vh - 394px)'
                  : 'calc(100vh - 494px)'
                : discoveryCategoryConfigType?.name == 'Financial Accounts'
                ? 'calc(100vh - 334px)'
                : 'calc(100vh - 434px)'
            "
          >
            @for(path of filteredPaths; track path ;let i = $index){
            <div class="w-[687px]">
              <mat-accordion multi="false">
                <mat-expansion-panel
                  [(expanded)]="expandedPanel[i]"
                  hideToggle
                  style="border-radius: 8px"
                  [expanded]="discoveryCategoryConfigType?.name === 'Financial Accounts' ? true : false"
                  [disabled]="discoveryCategoryConfigType?.name === 'Financial Accounts'"
                  class="discovery-accordion"
                >
                  <mat-expansion-panel-header class="discovery-accordion-header">
                    <div class="flex justify-between items-center w-full">
                      <div class="flex items-center">
                        @if(discoveryCategoryConfigType?.name !== "Financial Accounts"){ @if(expandedPanel[i]){
                        <mat-icon class="mr-2">expand_more</mat-icon>
                        }@else {
                        <mat-icon class="mr-2">chevron_right</mat-icon>
                        } }
                        <div class="title" appTooltip [toolTipText]="path?.name">{{ path?.path_name }}</div>
                        @if(filterForms(path)?.length){
                        <div class="dot-text">•</div>
                        <div class="members">{{ filterForms(path)?.length || 0 }} item<span *ngIf="filterForms(path)?.length > 1">s</span></div>
                        } @if(path?.tooltip){
                        <div>
                          <img class="ml-2 mt-[-1px]" [matTooltip]="path?.tooltip" src="assets/images/info-icon.svg" width="16px" height="16px" />
                        </div>
                        }
                      </div>

                      <div class="flex items-center">
                        <button class="matMenuTrigger" (click)="$event.stopPropagation(); addNewTemplateRow(i, path)">
                          <div class="add-new-button ml-4 cursor-pointer">
                            <img src="assets/images/plus-blue.svg" width="16px" height="16px" class="mr-2 mt-[-1px]" />Add New
                          </div>
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel-header>

                  <div class="discovery-card-content">
                    @if(isManualAccountsLoading && discoveryCategoryConfigType?.name === 'Financial Accounts'){
                    <div class="loader-container mt-3 flex-col w-full px-3">
                      @for (item of [1,2,3,4]; track item) {
                      <div class="w-full">
                        <div class="flex loader-body w-full">
                          <div class="ph-item width-100per loader-body-item pt-[20px]">
                            <div class="ph-col-12 p-0">
                              <div class="ph-row">
                                <div class="ph-col-12 h-10 p-0 m-0"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                    }@else{ @if(!path?.forms?.length){
                    <div class="pb-[18px] pl-[16px] pr-[16px] mt-[-4px]">
                      <div class="no-discovery-path-item">
                        <div><img class="w-[42px] h-[24px]" src="assets/images/noTemplatesShow.svg" /></div>
                        <div class="text-[#53565B] text-[12px] leading-none font-semibold font-open-sans" [innerHTML]="getZeroStateText(path)"></div>
                      </div>
                    </div>
                    }@else {
                    <div class="discovery-card-table border border-[#d3dce8b3] mb-6 bg-[#FFFFFF]">
                      <div class="flex">
                        @if(path?.template && path?.template2){
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[192px]">Name</div>
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[140px] border-x border-x-[#d3dce8b3]">
                          Type @if(discoveryCategoryConfigType.name !== 'Financial Accounts'){
                          <img
                            class="ml-2 mt-[-1px]"
                            [matTooltip]="getTooltipText('type')"
                            src="assets/images/info-icon.svg"
                            width="16px"
                            height="16px"
                          />
                          }
                        </div>
                        }@else {
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[333px]">Name</div>
                        } @if(path.data_type == 'Entities'){
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[200px] border-x border-x-[#d3dce8b3]">
                          Members
                          <img
                            class="ml-2 mt-[-1px]"
                            [matTooltip]="getTooltipText('members', path)"
                            src="assets/images/info-icon.svg"
                            width="16px"
                            height="16px"
                          />
                        </div>
                        }@else if((this.discoveryCategoryConfigType.category_type == 'contact') || (this.discoveryCategoryConfigType.category_type ===
                        'password')){
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[200px] border-x border-x-[#d3dce8b3]">
                          Owners
                          <img
                            class="ml-2 mt-[-1px]"
                            [matTooltip]="getTooltipText('owners')"
                            src="assets/images/info-icon.svg"
                            width="16px"
                            height="16px"
                          />
                        </div>
                        }@else {
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[200px] border-x border-x-[#d3dce8b3]">
                          Vault
                          <img
                            class="ml-2 mt-[-1px]"
                            [matTooltip]="getTooltipText('vault')"
                            src="assets/images/info-icon.svg"
                            width="16px"
                            height="16px"
                          />
                        </div>
                        }
                        <div class="discovery-card-table-header py-[10px] px-[16px] w-[150px]">Actions</div>
                      </div>
                      <div class="bg-white">
                        @for (row of filterForms(path); track row ;let rowIndex = $index) {
                        <discovery-template-table-form
                          [rowData]="row"
                          [isOwnerRegisterDataType]="isOwnerRegisterDataType"
                          [path]="path"
                          [index]="rowIndex"
                          [vaults]="vaults"
                          [userObject]="userObject"
                          [forms]="forms"
                          [registerType]="discoveryCategoryConfigType.category_type"
                          [allUserConnections]="allUserConnections"
                          [logInUser]="logInUser"
                          (remove)="removeTemplateRow(rowIndex, path, row)"
                          (update)="updateTemplateRow($event, rowIndex, path, row)"
                        ></discovery-template-table-form>
                        }
                      </div>
                    </div>
                    } }
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
            }
          </div>
        </div>
        }
      </div>
      } } @if(menus[selectedStepIndex] || isOwnerRegisterDataType){
      <div
        class="flex pt-6 border-t border-[#C1C2C5] absolute bottom-0"
        [ngClass]="{
          'w-[687px]': discoveryCategoryConfigType?.name == 'Financial Accounts',
          'w-full': discoveryCategoryConfigType?.name != 'Financial Accounts',
          'fl-justify-between': selectedStepIndex != 0,
          'justify-end': selectedStepIndex == 0
        }"
      >
        @if(selectedStepIndex != 0){
        <button class="white-footer-btn pointer" (click)="changeStep(-1)"><img src="assets/images/arraw-back.svg" />Back</button>
        } @if(menus[selectedStepIndex]) {
        <button class="blue-footer-btn pointer" (click)="changeStep(1)">Continue</button>
        }
      </div>
      }
    </section>
  </div>
</section>

<!-- <mat-sidenav-container class="example-container z-[99999]">
  <mat-sidenav
    id="sidenavContainer"
    #homePageDrawer
    [mode]="'side'"
    style="overflow-x: hidden; overflow-y: auto; visibility: visible !important"
    class="app__stepper__config-container"
    [ngClass]="{
        'top-[52px]': switchFromUser,
        'top-0': !switchFromUser
    }"
    [(opened)]="isDataExtractionOpened"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [disableClose]="true"
    (closed)="handleMainSideNav(false)"
    (opened)="handleMainSideNav(true)"
  >
    <div class="w-full h-full">
      @if (isDataExtractionOpened) {
          <non-document-form-data-extraction
            [isDataExtractionType]="isDataExtractionType"
            [categories]="categories"
          ></non-document-form-data-extraction>
        }
    </div>
  </mat-sidenav>
</mat-sidenav-container> -->
